import React from 'react';
import { Children } from 'react';
import { StoreSubscribe } from '../../../providers/global-store-provider';

export default class ShowIfRole extends React.Component {
    /*
    -----------------------------------------------------------------------
    RENDER Functions
    -----------------------------------------------------------------------
    */
    render() {
        let roles = this.props.roles;
        let notRoles = this.props.notRole
        if (typeof (roles) === 'string')
            roles = [roles];
        if (typeof (notRoles) === 'string')
            notRoles = [notRoles];
        const passedProps = { ...this.props };
        delete passedProps.children;
        let childrenWithProps = this.props.children;
        //Add parent props if the children and child is a function or an object
        if (["object", "function"].indexOf(typeof (this.props.children)) !== -1)
            childrenWithProps = this.props.children ? Children.map(this.props.children,
                child => ["object", "function"].indexOf(typeof(child)) === -1 ? child : React.cloneElement(child, { ...passedProps, ...child.props })) : [];
        return (
            <StoreSubscribe>
                {store => {
                    const userRoles = store.state.auth.user.roles || [store.state.auth.user.role];

                    for (let role in notRoles)
                        if (userRoles.indexOf(notRoles[role]) !== -1)
                            return <span />;
                    for (let role in roles)
                        if (userRoles.indexOf(roles[role]) !== -1)
                            return childrenWithProps;
                    return <span />;

                }}
            </StoreSubscribe>

        );
    }
}